import * as React from "react";
export default (function () { return (React.createElement("div", null,
    React.createElement("h3", null, "profile"))); });



//////////////////
// WEBPACK FOOTER
// ./app/modules/profile/index.tsx
// module id = z6N1
// module chunks = 2